import Image from "next/image";
import { useDetectDevice, useInApp } from "../../hooks";
import useTranslations from "../../hooks/useTranslations";
import { Button } from "../Button/Button";
import { useEffect, useState } from "react";

const DownloadLogoSvg = () => {
  return (
    <svg width="40" height="44" viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_7539_5681)">
      <path d="M2 18.7422C2 8.94345 9.94345 1 19.7422 1C29.5409 1 37.4844 8.94345 37.4844 18.7422V23.2578C37.4844 33.0566 29.5409 41 19.7422 41C9.94345 41 2 33.0566 2 23.2578V18.7422Z" fill="black" shapeRendering="crispEdges"/>
      <path d="M15.2344 13.5H24.2344C24.4444 13.5 24.6219 13.5725 24.7669 13.7175C24.9119 13.8625 24.9844 14.04 24.9844 14.25V27.75C24.9844 27.96 24.9119 28.1375 24.7669 28.2825C24.6219 28.4275 24.4444 28.5 24.2344 28.5H15.2344C15.0244 28.5 14.8469 28.4275 14.7019 28.2825C14.5569 28.1375 14.4844 27.96 14.4844 27.75V14.25C14.4844 14.04 14.5569 13.8625 14.7019 13.7175C14.8469 13.5725 15.0244 13.5 15.2344 13.5ZM19.7344 24.75C19.5244 24.75 19.3469 24.8225 19.2019 24.9675C19.0569 25.1125 18.9844 25.29 18.9844 25.5C18.9844 25.71 19.0569 25.8875 19.2019 26.0325C19.3469 26.1775 19.5244 26.25 19.7344 26.25C19.9444 26.25 20.1219 26.1775 20.2669 26.0325C20.4119 25.8875 20.4844 25.71 20.4844 25.5C20.4844 25.29 20.4119 25.1125 20.2669 24.9675C20.1219 24.8225 19.9444 24.75 19.7344 24.75Z" fill="white"/>
      </g>
      <defs>
      <filter id="filter0_d_7539_5681" x="0" y="0" width="39.4844" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="1"/>
      <feGaussianBlur stdDeviation="1"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7539_5681"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7539_5681" result="shape"/>
      </filter>
      </defs>
    </svg>
  )
}

export const AppDownloadBanner = () => {
  const isInApp = useInApp();
  const translate = useTranslations();
  const device = useDetectDevice();

  const [appDownloadBanner, setAppDownloadBanner] = useState(false);

  const onCloseClock = () => {
    sessionStorage.setItem("appDownloadBanner", "false");
    setAppDownloadBanner(false);
  }

  useEffect(() => {
    if (device.isBrowser || isInApp) {
      setAppDownloadBanner(false);
      return;
    }

    if (sessionStorage.getItem("appDownloadBanner") === "false") {
      setAppDownloadBanner(false);
    } else {
      setAppDownloadBanner(true);
    }
  }, [isInApp, device]);

  const goAppDownload = () => {
    if (device.isAndroid) {
      window.open(`https://play.google.com/store/apps/details?id=com.softsquared.disco.vn`, '_blank');
    } else if (device.isIOS) {
      window.open(`https://apps.apple.com/us/app/disco-th%E1%BB%9Di-trang-chu%E1%BA%A9n-sao/id6746246347`, '_blank');
    }
  }

  if (!appDownloadBanner || isInApp) {
    return null;
  }

  return (
    <div className="mb-[100px] w-full max-w-[530px]">
      <div className="max-w-[530px] gap-[8px] h-[100px] w-full pt-[22px] pb-[22px] flex align-center justify-between pl-[10px] pr-[10px] fixed" style={{background: "linear-gradient(170deg, #F3E8FF, #FDF2F8, #FFEDD5)"}}>
        <div className="flex justify-center items-center">
          <DownloadLogoSvg />
        </div>
        <div className="w-full flex flex-col gap-[8px] justify-center items-left min-w-max">
          <span className="text-[14px] color-black">{translate.translations.appDownloadBanner?.title}</span>
          <span className="text-[12px] color-[#4B5563]">{translate.translations.appDownloadBanner?.subTitle}</span>
        </div>
        <div className="w-full flex justify-center items-center">
          <Button className="text-white p-[12px] rounded-[8px] bg-black w-[full]" onClick={() => goAppDownload()}>
            <div className="flex flex-row gap-[6px] justify-center">
              <Image width={15} height={20} src="/assets/install.svg" alt="Install" draggable={false} />
              {translate.translations.appDownloadBanner?.button}
            </div>
          </Button>
        </div>
        <div className="min-w-[18px] flex justify-center items-center">
          <Image width={18} height={18} src="/assets/close2.svg" alt="Close" draggable={false} onClick={() => onCloseClock()} />
        </div>
      </div>
    </div>
  )
}